module.exports = new __parcel__URL__("battleroyale_results_divider.95fe4c66.png").toString();